import { NavLink } from 'react-router-dom';

import { cn } from '@/lib/utils.js';

/**
 * Top-level switch for the Experience page. Kadanza's sidebar links to the
 * extension as a single entry, so anything past the landing view needs its own
 * way in — without this, a user who sends a distribution has no route back to
 * it beyond the browser history.
 *
 * Detail views deliberately omit these and offer a back link instead, so that
 * a page reached from a row does not present a second way to leave it.
 */
const TABS = [
  { to: '/experience', label: 'Projects', end: true },
  { to: '/experience/distributions', label: 'Distributions', end: false },
];

export function ExperienceTabs() {
  return (
    <div className="mb-6 flex gap-1 border-b border-line">
      {TABS.map((tab) => (
        <NavLink
          key={tab.to}
          to={tab.to}
          end={tab.end}
          className={({ isActive }) =>
            cn(
              '-mb-px border-b-2 px-3 py-2 text-sm font-medium transition',
              isActive ? 'border-brand text-ink' : 'border-transparent text-muted hover:text-body',
            )
          }
        >
          {tab.label}
        </NavLink>
      ))}
    </div>
  );
}
